export const iconFontAwesomeArrowsAngleLeft = (
	<i className="fa-solid fa-angle-left"></i>
);
